import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { RegiaoResponse } from '../models/region.model';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';

@Injectable({
  providedIn: 'root',
})
export class RegiaoApiService extends UtilsBaseApiService<RegiaoApiService> {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('regiao', injector, environment.BASE_API_URL);
  }

  getRegiao = () => this.getAll<Observable<RegiaoResponse[]>>();
}
